import React, { useEffect, useRef, useState } from "react";

const SystemFutureSection = ({ overviewCards, futureCards }) => {
  const sectionRef = useRef();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setIsVisible(true);
      },
      { threshold: 0.3 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="hris-system-future-section py-5" ref={sectionRef}>
      <div className="container">

        {/* System Overview */}
        <h2 className="text-center fw-bold mb-4 hris-section-title">System Overview</h2>
        <div className="row text-center mb-5">
          {overviewCards.map((card, i) => (
            <div className="col-12 col-sm-6 col-lg-3 mb-4 d-flex" key={i}>
              <div
                className={`hris-overview-card d-flex flex-column justify-content-start align-items-center w-100 ${
                  isVisible ? (i % 2 === 0 ? "hris-slide-top" : "hris-slide-bottom") : ""
                }`}
              >
                <img
                  src={card.image}
                  alt={card.title}
                  width="100"
                  height="100"
                  className="rounded-circle mb-3"
                />
                <h5 className="fw-bold hris-card-title text-center">{card.title}</h5>
                <p className="text-muted hris-card-description text-center">{card.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* The Future of Work */}
        <div className="row align-items-center gx-3 future-work-horizontal">
          <div className="col-lg-2 col-12 text-lg-end text-center mb-4 mb-lg-0">
            <div className="future-work-title-wrapper">
              <h2 className="fw-bold mb-0 future-work-line">The</h2>
              <h2 className="fw-bold future-work-line">Future of Work</h2>
            </div>
          </div>
          <div className="col-lg-10 col-12">
            <div className="row justify-content-center text-center">
              {futureCards.map((card, i) => (
                <div className="col-4 col-sm-3 col-md-2 mb-4 d-flex" key={i}>
                  <div
                    className={`hris-future-card d-flex flex-column align-items-center w-100 ${
                      isVisible ? "hris-slide-left" : ""
                    }`}
                  >
                    <img
                      src={card.image}
                      alt={card.title}
                      width="100"
                      height="100"
                      className="rounded-circle mb-2"
                    />
                    <h6 className="fw-bold hris-card-title text-center">{card.title}</h6>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default SystemFutureSection;
